import { render } from "./AutosizeTextArea.vue?vue&type=template&id=15ae9c99&scoped=true"
import script from "./AutosizeTextArea.vue?vue&type=script&lang=js"
export * from "./AutosizeTextArea.vue?vue&type=script&lang=js"

import "./AutosizeTextArea.vue?vue&type=style&index=0&id=15ae9c99&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ae9c99"]])

export default __exports__